import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';

import { PromoIcon } from 'components/no-auth/common/PromoIcon/PromoIcon';
import { PromoText } from 'components/no-auth/common/PromoText/PromoText';
import Auth from 'components/no-auth/header/Auth';

import { CorrespondNav, OverlayNavigation, TabIcon, TabNameMobile, TopMenuIcon, FixedPanel, NavigationWrapper, MenuLink } from './styles';

const HeaderMobile = (props) => {
    const [openedIndex, setOpenedIndex] = useState(null);

    const toggleItem = (e, index) => {
        e.preventDefault();
        if (index === openedIndex) {
            setOpenedIndex(null);
        } else {
            setOpenedIndex(index);
        }
    };

    const location = useLocation();

    const linkIsSelected = (link) => link.nav_links.some((nl) => nl.url === location.pathname);
    const navLinkIsSelected = (navlink) => navlink.url === location.pathname;

    if (props.libre) {
        return false;
    } else {
        return (
            <OverlayNavigation>
                <NavigationWrapper>
                    <CorrespondNav>
                        {props.data &&
                            props.data
                                .filter((link) => !link?.authorised_user)
                                .map((link, index) => {
                                    return (
                                        <div key={index}>
                                            <TabNameMobile
                                                onClick={(e) => toggleItem(e, index)}
                                                onKeyPress={(e) => toggleItem(e, index)}
                                                isSelected={linkIsSelected(link)}
                                                tabIndex={'0'}
                                            >
                                                <PromoText variant="subheader" color="gray80">
                                                    {link.title}
                                                </PromoText>
                                                <TabIcon isOpenedTab={openedIndex === index}>
                                                    <PromoIcon name="chevron-down" color="gray80" size="24px" />
                                                </TabIcon>
                                            </TabNameMobile>
                                            {openedIndex === index && (
                                                <ul>
                                                    {link.nav_links
                                                        .filter((item) => item !== null)
                                                        .map((navlink) => {
                                                            return (
                                                                <PromoText tag="listItem" color="gray80" key={navlink.id}>
                                                                    <MenuLink
                                                                        href={navlink.url}
                                                                        title={navlink.title}
                                                                        target={navlink.isBlank ? '_blank' : null}
                                                                        isSelected={navLinkIsSelected(navlink)}
                                                                        tabIndex={'0'}
                                                                    >
                                                                        {navlink?.icon?.url && (
                                                                            <TopMenuIcon
                                                                                src={navlink.icon?.url}
                                                                                alt={navlink.title}
                                                                                width={'24'}
                                                                                height={'24'}
                                                                            />
                                                                        )}
                                                                        {navlink.title}
                                                                    </MenuLink>
                                                                </PromoText>
                                                            );
                                                        })}
                                                </ul>
                                            )}
                                        </div>
                                    );
                                })}
                    </CorrespondNav>
                </NavigationWrapper>
                {props.authData && (
                    <FixedPanel>
                        <Auth isLanding={props.isLanding} pageName={props.pageName} data={props.authData} />
                    </FixedPanel>
                )}
            </OverlayNavigation>
        );
    }
};

export default HeaderMobile;
